if (!customElements.get('product-gift-wrap')) {
  customElements.define(
    'product-gift-wrap',
    class ProductGiftWrap extends HTMLElement {
      connectedCallback() {
        const data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.variantId = data.variantId;
        this.wrapPrice = data.wrapPrice;
        this.boxPrice = data.boxPrice;
        this.moneyFormat = data.moneyFormat;
        this.messageLabel = data.messageLabel;
        this.messageLimit = data.messageLimit;
        this.wordLimit = data.wordLimit || 0;
        // drafts keep each box's message when the quantity drops or the wrap is unticked.
        this.drafts = [];

        this.checkbox = this.querySelector('.product-gift-wrap__checkbox');
        this.fields = this.querySelector('.product-gift-wrap__fields');
        this.messagesEl = this.querySelector('.product-gift-wrap__messages');
        this.limitId = this.querySelector('.product-gift-wrap__limit').id;

        const sectionId = this.dataset.sectionId;
        this.quantityInput = document.getElementById(`Quantity-${sectionId}`);
        this.submitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);

        this.checkbox.addEventListener('change', () => {
          this.render();
          if (this.checkbox.checked) this.messagesEl.querySelector('textarea')?.focus();
        });
        this.messagesEl.addEventListener('input', (event) => {
          if (event.target.tagName !== 'TEXTAREA') return;
          this.capWords(event.target);
          this.drafts[parseInt(event.target.dataset.index, 10)] = event.target.value;
        });
        // The quantity buttons change the input's value and fire 'change'.
        this.quantityInput?.addEventListener('change', () => this.render());
        this.quantityInput?.addEventListener('input', () => this.render());

        this.render();
      }

      get checked() {
        return this.checkbox.checked;
      }

      boxes() {
        return Math.max(1, parseInt(this.quantityInput?.value, 10) || 1);
      }

      render() {
        const count = this.checked ? this.boxes() : 0;
        const existing = this.messagesEl.querySelectorAll('.product-gift-wrap__message');
        for (let i = existing.length; i < count; i++) this.messagesEl.append(this.buildMessage(i));
        for (let i = count; i < existing.length; i++) existing[i].remove();
        this.fields.hidden = !this.checked;
        this.updateTotal();
      }

      // "Add to cart · $52.00": the box price times the quantity, plus a wrap per box when ticked.
      updateTotal() {
        if (!this.submitButton) return;
        let total = this.submitButton.querySelector('.product-gift-wrap__total');
        if (!total) {
          total = document.createElement('span');
          total.className = 'product-gift-wrap__total';
          this.submitButton.querySelector('span').after(total);
        }
        const boxes = this.boxes();
        const cents = boxes * this.boxPrice + (this.checked ? boxes * this.wrapPrice : 0);
        total.textContent = ` · ${this.formatMoney(cents)}`;
      }

      formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) =>
          key === 'amount_no_decimals' ? withCommas.split('.')[0] : withCommas
        );
      }

      buildMessage(index) {
        const id = `ProductGiftWrap-${this.dataset.sectionId}-${index + 1}`;
        const wrapper = document.createElement('div');
        wrapper.className = 'product-gift-wrap__message';

        const label = document.createElement('label');
        label.htmlFor = id;
        label.textContent = this.messageLabel.replace('[n]', index + 1);

        const field = document.createElement('div');
        field.className = 'field';
        const textarea = document.createElement('textarea');
        textarea.id = id;
        textarea.className = 'text-area field__input';
        textarea.rows = 3;
        textarea.maxLength = this.messageLimit;
        textarea.dataset.index = index;
        textarea.setAttribute('aria-describedby', this.limitId);
        textarea.value = this.drafts[index] || '';
        field.append(textarea);

        wrapper.append(label, field);
        if (this.wordLimit) {
          const words = document.createElement('p');
          words.className = 'product-gift-wrap__words caption';
          words.setAttribute('aria-live', 'polite');
          wrapper.append(words);
          this.updateWordCount(textarea, words);
        }
        return wrapper;
      }

      // Same rule as the cart: extra words are cut as they're typed, and the count says how many are used.
      capWords(textarea) {
        if (!this.wordLimit) return;
        const words = textarea.value.match(/\S+/g) || [];
        if (words.length > this.wordLimit) {
          let seen = 0;
          const cut = textarea.value.replace(/\S+/g, (word) => (++seen <= this.wordLimit ? word : ''));
          textarea.value = cut.replace(/\s+$/, '');
        }
        this.updateWordCount(textarea);
      }

      updateWordCount(textarea, counter) {
        counter = counter || textarea.closest('.product-gift-wrap__message')?.querySelector('.product-gift-wrap__words');
        if (!counter) return;
        const used = (textarea.value.match(/\S+/g) || []).length;
        counter.textContent = `${used} of ${this.wordLimit} words`;
      }

      limitText(text) {
        let out = (text || '').trim();
        if (this.wordLimit) out = (out.match(/\S+/g) || []).slice(0, this.wordLimit).join(' ');
        return out.slice(0, this.messageLimit);
      }

      // One wrap line per box, each with its own message. A blank message is left for the cart,
      // which asks for it (or a "no message" tick) before checkout.
      wrapItems(boxes) {
        return Array.from({ length: boxes }, (_, i) => {
          const message = this.limitText(this.drafts[i]);
          return { id: this.variantId, quantity: 1, properties: message ? { Message: message } : {} };
        });
      }
    }
  );
}
